import { PushNotificationService, WebSocketService } from "@hypexone/uicore";
import { getBaseUrl } from "../api/api-services/environment-url/environment-url";

export const pnService = new PushNotificationService(
    getBaseUrl(
        import.meta.env.VITE_NODE_ENV,
        'REACT_APP_WEBSOCKET_URL_PUSH_NOTIFICATIONS'
    )
);

export const websocketService = new WebSocketService();